<template>
    <div>
        <slot name="Empty" v-if="empty" />
        <template v-else>
            <slot />
        </template>
    </div>
</template>

<script>
    export default {
        name: 'ScrollView',
        props: {
            refreshing: {
                type: Boolean,
                default: false
            },
            empty: {
                type: Boolean,
                default: false
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>